import { useEffect } from "react";
import { LANGUAGES, useLang, withLang } from "@/i18n";
import { META } from "@/seo/meta";

const SITE_NAME = "HEAVY METAL";
const DEFAULT_IMAGE = "/images/hero.jpg";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href, hreflang) {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (hreflang) el.setAttribute("hreflang", hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({ title, description, image, type = "website", noindex = false, metaKey, single = false }) {
  const { lang, path } = useLang();

  useEffect(() => {
    const origin = window.location.origin;
    const localized = lang !== "ro" && metaKey ? META[lang]?.[metaKey] : null;
    const rawTitle = localized?.[0] || title;
    const desc = localized?.[1] || description;
    const fullTitle = rawTitle.includes(SITE_NAME) ? rawTitle : `${rawTitle} | ${SITE_NAME}`;
    const img = image && image.startsWith("http") ? image : `${origin}${image || DEFAULT_IMAGE}`;
    const url = `${origin}${withLang(lang, path)}`;
    const locale = LANGUAGES.find((l) => l.code === lang)?.locale || "ro_RO";

    document.title = fullTitle;
    document.documentElement.lang = lang;
    setMeta("name", "description", desc);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
    setLink("canonical", url);

    document.head.querySelectorAll('link[rel="alternate"][hreflang]').forEach((el) => el.remove());
    if (!noindex && !single) {
      LANGUAGES.forEach((l) => setLink("alternate", `${origin}${withLang(l.code, path)}`, l.code));
      setLink("alternate", `${origin}${path}`, "x-default");
    }

    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", SITE_NAME);
    setMeta("property", "og:locale", locale);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", img);
  }, [title, description, image, type, noindex, metaKey, single, lang, path]);

  return null;
}
